import { render } from "./TripDurationPanel.vue?vue&type=template&id=5f39228e&scoped=true"
import script from "./TripDurationPanel.vue?vue&type=script&lang=js"
export * from "./TripDurationPanel.vue?vue&type=script&lang=js"

import "./TripDurationPanel.vue?vue&type=style&index=0&id=5f39228e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f39228e"]])

export default __exports__